import React, { useRef, useState } from "react";
import { Cell } from "fixed-data-table-2";
import { OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import AddStudentsToTableOverlay from "../AddStudentToTableOverlay";
import useUserRole from "../../../../../../../utils/hooks/useUserRole";

type Props = {};

const AddStudentsHeaderCell: React.FunctionComponent<Props> = (props) => {
  const [showAddStudentsOverlay, setShowAddStudentsOverlay] = useState<boolean>(
    false
  );
  const { isTeacher } = useUserRole();
  const addRef = useRef(null);

  const handleAddClick = () => {
    setShowAddStudentsOverlay((prevState) => !prevState);
  };

  const onHideAddOverlay = () => {
    setShowAddStudentsOverlay(false);
  };

  return (
    <Cell>
       <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="top"
        overlay={
          showAddStudentsOverlay ? (
            <div />
          ) : (
            <Tooltip className="customTooltip" id="tooltip-top">
              Add {!isTeacher ? "new or" : ""} existing student(s).
            </Tooltip>
          )
        }
      >
        <span
          onClick={handleAddClick}
          ref={addRef}
          className="showFiltersButton"
        >
          <FontAwesomeIcon icon={faPlusCircle} size="lg" color={"black"} />
        </span>
      </OverlayTrigger>
      <AddStudentsToTableOverlay
        placement={"bottom"}
        showOverlay={showAddStudentsOverlay}
        buttonRef={addRef}
        onHide={onHideAddOverlay}
      />
    </Cell>
  );
};

export default AddStudentsHeaderCell;
